import React, { useEffect, useState, createContext } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import ArticleView from './pages/ArticleView';
import AdminPanel from './pages/AdminPanel';
import ResetPassword from './pages/ResetPassword';
import Methodology from './pages/Methodology';
import WaterFieldGuide from './pages/WaterFieldGuide';
import { AudioProvider } from './components/AmbientAudio';
import { CursorGlow } from './components/CursorGlow';
import { CommandPalette } from './components/CommandPalette';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const AuthContext = createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void Promise.resolve().then(() => { checkAuth(); });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#08080A]">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, setUser, checkAuth }}>
      <AudioProvider>
        <div className="App">
          <div className="grain-overlay" aria-hidden="true" />
          <CursorGlow />
          <BrowserRouter>
            <CommandPalette key={user?.id || 'anon'} />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/article/:id" element={<ArticleView />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/method" element={<Methodology />} />
              <Route path="/guides/off-grid-water-systems" element={<WaterFieldGuide />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </AudioProvider>
    </AuthContext.Provider>
  );
}

export default App;
